import React, { useState, ReactNode } from 'react';
import { Container, Modal, Button, Backdrop, Fade } from '@material-ui/core/';

import './style.css';
import { optionStyles } from './style';

interface IProps {
  component?: ReactNode;
}

const OnModal: React.FC<IProps> = (component) => {
  const classes = optionStyles();

  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <>
          <Fade in={open}>
            <div className="Paper">
              {component.children}
            </div>

          </Fade>
          <Button variant="contained" className={classes.buttonClose} onClick={handleClose}>
            Fechar
          </Button>
        </>
      </Modal>

      <Container className={classes.root}>
        <Button variant="outlined" className={classes.button} onClick={handleOpen}>
          Ver gráfico
        </Button>
        <div className={classes.modalCharts}>
          {component.children}
        </div>
      </Container>
    </>
  );
};

export default OnModal;
